import Component from '@glimmer/component';
import { service } from '@ember/service';
import LoadingService from 'madow-tech/services/loading';

export default class LanguageLoadingOverlay extends Component {
  @service('loading') loading!: LoadingService;

  <template>
    {{#if this.loading.isLanguageLoading}}
      <div
        class="language-loading-overlay fixed inset-0 z-[9999] pointer-events-auto"
        style="display: block;"
        role="status"
        aria-live="polite"
        aria-label="Loading translations"
      >
        {{! Fade overlay - keep stars visible behind with reduced opacity }}
        <div class="absolute inset-0 bg-black/70 backdrop-blur-md"></div>

        {{! Loading indicator }}
        <div class="absolute inset-0 flex items-center justify-center">
          <div class="text-center">
            <div class="inline-block animate-spin rounded-full h-12 w-12 border-4 border-rose-300 border-t-transparent mb-4 drop-shadow-[0_0_10px_rgba(251,113,133,0.5)]"></div>
            <p class="text-zinc-300 text-sm font-medium drop-shadow-[0_0_5px_rgba(0,0,0,0.8)]">Loading translations...</p>
          </div>
        </div>
      </div>
    {{else}}
      <div
        class="language-loading-overlay fixed inset-0 z-[9999] pointer-events-none"
        style="display: none;"
        aria-hidden="true"
      ></div>
    {{/if}}
  </template>
}

